export const GET_THONG_BAO = "GET_THONG_BAO";
export const GET_THONG_BAO_SUCCESS = "GET_THONG_BAO_SUCCESS";
export const GET_THONG_BAO_FAILURE = "GET_THONG_BAO_FAILURE";
export const UPDATE_THONG_BAO = "UPDATE_THONG_BAO";
export const UPDATE_THONG_BAO_SUCCESS = "UPDATE_THONG_BAO_SUCCESS";
export const UPDATE_THONG_BAO_FAILURE = "UPDATE_THONG_BAO_FAILURE";

export const GET_LIST_THONG_BAO = "GET_LIST_THONG_BAO";
export const GET_LIST_THONG_BAO_SUCCESS = "GET_LIST_THONG_BAO_SUCCESS";
export const GET_LIST_THONG_BAO_FAILURE = "GET_LIST_THONG_BAO_FAILURE";
export const SHOW_THONG_BAO = "SHOW_THONG_BAO";
